<script>
import TocItem from './TocItem.vue';

export default {
    name: 'SectionToc',
    components: { TocItem },
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tocItems: []
        }
    },
    methods: {
        parseToc() {
            if (!this.content) {
                this.tocItems = [];
                return;
            }

            // Create a temporary DOM element to parse the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = this.content;

            // Find the TOC navigation
            const tocNav = tempDiv.querySelector('nav.toc');
            if (!tocNav) {
                this.tocItems = [];
                return;
            }

            // Parse the TOC structure recursively
            this.tocItems = this.parseTocList(tocNav.querySelector('ul'));
        },
        parseTocList(ul) {
            if (!ul) return [];

            const items = [];
            const liElements = ul.querySelectorAll(':scope > li');

            liElements.forEach(li => {
                const linkSpan = li.querySelector(':scope > span.toc-link');
                const nestedUl = li.querySelector(':scope > ul');

                if (linkSpan) {
                    const scrollId = linkSpan.getAttribute('data-scroll-tock-id');
                    const text = linkSpan.textContent.trim();

                    items.push({
                        id: scrollId,
                        text: text,
                        children: this.parseTocList(nestedUl)
                    });
                }
            });

            return items;
        },
        scrollToSection(id) {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            }
        }
    },
    watch: {
        content: {
            immediate: true,
            handler() {
                this.parseToc();
            }
        }
    }
}
</script>

<template>
    <nav v-if="tocItems.length > 0" class="section-toc">
        <div class="toc-heading">Оглавление</div>
        <ul class="toc-list">
            <toc-item 
                v-for="item in tocItems" 
                :key="item.id" 
                :item="item"
                :level="0"
                @scroll="scrollToSection"
            />
        </ul>
    </nav>
</template>

<style scoped>
.section-toc {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 20px;
    position: sticky;
    top: 100px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    transition: all 0.3s ease;
}

.toc-heading {
    font-size: 16px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #e5e7eb;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.toc-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

/* Scrollbar styling */
.section-toc::-webkit-scrollbar {
    width: 6px;
}

.section-toc::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.section-toc::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
}

.section-toc::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
}

/* Mobile styles */
@media (max-width: 1200px) {
    .section-toc {
        display: none;
    }
}
</style>
